import React from 'react';

function Testimonials() {
  return (
    <section className="tc-testimonials-style1">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <h6 className="fsz-18 text-uppercase lh-4">
              what clients say <br /> about us
            </h6>
            <div className="lg-icon color-orange1">
              <i className="la la-quote-right"></i>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="tc-clients-style1">
              <div className="clients-slider1">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div className="text fsz-35 fw-600 lh-2 js-splittext-lines">
                        “The team at Artisan Guild Infra delivered exceptional results 
                        through advanced steel structures, canopy cladding, and automated 
                        glass systems. Their ability to merge functionality with refined 
                        aesthetics elevated the entire facility’s architectural appeal.”
                      </div>
                      <div className="author">
                        <div className="au-img">
                          <img
                            src="/home2/assets/img/man.jpg"
                            alt=""
                            className="img-cover"
                          />
                        </div>
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">
                            Project Consultant
                          </h6>
                          <p className="text-capitalize fsz-14 color-666">
                            Tulah Clinical Wellness Sanctuary
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div className="text fsz-35 fw-600 lh-2 js-splittext-lines">
                        “AGI transformed Hilite Mall with an impressive glass façade, 
                        canopy, and entry systems that perfectly balance design and 
                        durability. Their commitment to quality and attention to detail 
                        made them a trusted partner throughout the project.”
                      </div>
                      <div className="author">
                        <div className="au-img">
                          <img
                            src="/home2/assets/img/man.jpg"
                            alt=""
                            className="img-cover"
                          />
                        </div>
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">
                            Mall Operations Head
                          </h6>
                          <p className="text-capitalize fsz-14 color-666">
                            Hilite Mall, Calicut
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div className="text fsz-35 fw-600 lh-2 js-splittext-lines">
                        “The façade and spider glazing work by Artisan Guild Infra at Coxswain23 
                        was handled with remarkable precision and professionalism. Managing over
                         100,000 sq. ft. of façade area is no small task, yet AGI executed it 
                         flawlessly, giving the building a sleek and modern identity.”
                      </div>
                      <div className="author">
                        <div className="au-img">
                          <img
                            src="/home2/assets/img/man.jpg"
                            alt=""
                            className="img-cover"
                          />
                        </div>
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">
                            Project Engineer
                          </h6>
                          <p className="text-capitalize fsz-14 color-666">
                           Coxswain23, Calicut
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slider-controls">
                  <div className="swiper-button-prev"></div>
                  <div className="swiper-pagination"></div>
                  <div className="swiper-button-next"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="marq-slider">
        <div className="swiper-wrapper">
          <div className="swiper-slide">
            <a href="#"> Creative </a>
          </div>
          <div className="swiper-slide">
            <a href="#"> Flexible </a>
          </div>
          <div className="swiper-slide">
            <a href="#"> Dedicated </a>
          </div>
        </div>
      </div>
      <img src="/innerpages/assets/img/c_line3.png" alt="" className="c-line" />
    </section>
  );
}

export default Testimonials;
